import * as API from "../";
export default {
  //所有频台
  platforms: (params) => {
    return API.POST("/api/third/platform/getAllList", params);
  },
  // 设备类型列表
  getList: (params) => {
    return API.POST("/api/third/device/getList", params);
  },
  // 设备类型列表
  bindList: (params) => {
    return API.POST("/api/third/device/getNoBindList", params);
  },
  insert: (params) => {
    return API.postJsonRequest("/api/third/device/addDevice", params);
  },
  delete: (params) => {
    return API.postJsonRequest("/api/third/device/delete/" + params);
  },
  dictList: (params) => {
    return API.POST("/api/third/device/type/getAllList", params);
  },
  regist: (params) => {
    return API.POST("/api/third/device/regist/" + params);
  }
};



// WEBPACK FOOTER //
// ./src/api/third/device.js